import { Observable } from 'rxjs';
import { Component, OnInit, HostListener } from '@angular/core';
import { State } from './redux/reducers';
import { select, Store } from '@ngrx/store';
import { getDirectLoggedIn } from '@uxdf/direct-shared-lib';
import { InitialLocaleLoaderService } from '@uxdf/locale-manager';
import * as svg4everybody from 'svg4everybody/dist/svg4everybody';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl:  './app.component.html'
})
export class AppComponent implements OnInit {
  isLoggedIn$!: Observable<boolean>;
  private _isLoggedIn = false;
  // provideNoopAnimations() in app.module already disables all animations
  // globally. Adding @HostBinding('@.disabled') on top of that causes Angular
  // 21's NoopAnimationDriver to treat the @.disabled state-change as a pending
  // transition, which prevents child *ngIf blocks from rendering on the first
  // change-detection cycle. Remove the host binding; NoopAnimations is enough.
  public isAppLoadedForSSO: boolean;

  constructor(private readonly store: Store<State>, private readonly initialLocale: InitialLocaleLoaderService) {
    this.isAppLoadedForSSO = localStorage.getItem('source')?.toLocaleLowerCase() === 'ash' || localStorage.getItem('source')?.toLocaleLowerCase() === 'snow';
  }

  @HostListener('contextmenu', ['$event']) onRightClick(event: Event) {
    // Prevent browser context menu (and autofill/password-manager popups) when
    // the user is not yet authenticated, and always for SSO-embedded sessions.
    if (this.isAppLoadedForSSO /* || !this._isLoggedIn */) {
      event.preventDefault();
    }
  }

  ngOnInit() {
    this.initialLocale.init();
    svg4everybody();
    this.isLoggedIn$ = this.store.pipe(select(getDirectLoggedIn));
    // Keep a synchronous snapshot so onRightClick never races with the async pipe
    this.isLoggedIn$.subscribe(v => { this._isLoggedIn = !!v; });
  }
}
